import { Component, OnInit ,Input, Output, EventEmitter} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { CustomServiceService } from '../../service/custom-service.service';
import {  EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment'; 
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-mis-kpi-zones',
  templateUrl: './mis-kpi-zones.component.html',
  styleUrls: ['./mis-kpi-zones.component.css'] 
}) 
export class MisKpiZonesComponent implements OnInit {
  spans: any;

  constructor(private httpservice: CustomServiceService,private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute, private encDec: EncryptDecryptService, public translate: TranslateService, private route: Router,) { 
  
  }
  language: any = sessionStorage.getItem('locale'); //dynamic content language translation 
  backend_url: any = environment.serviceURL;
  start:number=0;
  limit:number=10;
  currentPage:number = 1;
  totalRecords:number=0;
  plugin_menu_dtl:any;
  employee_con:any="";
  showEmpMen:boolean=false;
  showNavComponent:boolean=false;
  showBarComponent:boolean=false;
  Ltype:any;
  isdisplay: boolean = false;
  circularDivList:any[]=[];
  CurrentRouteFn:any = ():any => {
    let route_url:any = this.route.url.replace('/',"");
    route_url = route_url.split("?");
    if(route_url.length > 0){
      return route_url[0];
    }
    return route_url;
  }


  CURRENT_ZONE_ID:any = environment.ZONE_ID;
  CURRENT_REGION_ID:any = environment.REGION_ID;
  CURRENT_ZONE_CODE:any = environment.ZONE_CODE;
  CURRENT_REGION_CODE:any = environment.REGION_CODE;
  datetime:any = this.httpservice.currentDateTime(); 
  ngOnInit(): void {
    this.getDivisionList();
 
    this.start=(this.currentPage - 1)*this.limit;
   

    if(environment.ZONE_ID > 0){
      setTimeout(()=>{
        this.getmiskpiZoneData('','','','',environment.ZONE_ID,'',this.start,this.limit,this.currentPage);
      },1000)
        this.GetAllZoneById(environment.ZONE_ID);
        this.GetRegion(environment.ZONE_ID);
     } else {
      setTimeout(()=>{
        this.getmiskpiZoneData('','','','','','',this.start,this.limit,this.currentPage);
      },1000)
      this.ZoneList();
     }
    
  }
  RefreshBtn:boolean=false;
  RefreshPage(){
    this.start=0;
    this.limit=10;
    this.currentPage = 1;
    this.totalRecords = 0;
    this.getmiskpiZoneData('','','','',environment.ZONE_ID,'',this.start,this.limit,this.currentPage);
    this.RefreshBtn = false;
    this.searchForm.reset();
   
  }
  searchForm = new FormGroup({
    division: new FormControl(''),
    title: new FormControl(''),
    category: new FormControl(''),
    periodicity:new FormControl(''),
    zone: new FormControl(''),
    region: new FormControl('')

  });
  content_apiresponse:any;
  misZoneList:any;
  countDiv:any;
  miskpiZoneList:any;
  name:any;
  prevDiv:any; 
  currDiv:any;
  getDivisionList(){

    let params = [{
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": '',
      "orderBy": [{ "columnName": "VCHDIVISIONEN", "type": "ASC" }],
      "condition": [
        { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
        { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" },
        { "columnName": "DIVISION_TYPE", "operator": "in", "value": '1,4', "joinoperator": "and" }
      ],
      "viewParameters": ""
    }];
    this.fciwebservice.getCircularDivision(params).subscribe((response: HttpEvent<any>)=>{
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.content_apiresponse = response.body;
  
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.circularDivList = response.result.sec_1;
            // console.log(this.circularDivList);
          } 
      }
  
    });
  }
  
  getmiskpiZoneData(title:any,division:any,category:any,periodicity:any,zone:any,region:any,start:number,limit:number,currentPage:number){
    var query:any=[];
    query = [
      {"columnName":"VCHORIGIN","operator":"=","value":2,"joinoperator":"and"},
      {"columnName":"bitDeletedFlag","operator":"=","value":0,"joinoperator":"and"},
      {"columnName":"tinPublishStatus","operator":"=","value":1,"joinoperator":"and"}
  ]; 
    let params = [{
      "secSlNo":1,
        "offSet": start,
        "noOfRecords":limit,
        "orderBy":[{"columnName":"INTCIRCULARDIV","type":"ASC"}],
        "condition":query,
        "viewParameters":""
    }];
    if(title!==""){
      query.push({ "columnName": "VCHTITILEEN", "operator": "LIKE", "value": `%${title}%`, "joinoperator": "and" });
    }
    if(division!==""){
        query.push({ "columnName": "INTCIRCULARDIV", "operator": "=", "value": division, "joinoperator": "and" });
      }
      if(zone!==""){
        if(zone!==null){
          query.push({ "columnName": "ZONE_ID", "operator": "=", "value": zone, "joinoperator": "and" });
        }
      }
      // if(region!==""){
      //   if(region!==null){
      //     query.push({ "columnName": "REGION_ID", "operator": "=", "value": region, "joinoperator": "and" });
      //   }
      // }
      if(category!==""){
        query.push({ "columnName": "VCHCATEGORY", "operator": "=", "value": category, "joinoperator": "and" });
      }
      if(periodicity!==""){
        query.push({ "columnName": "VCHPERIODCITY", "operator": "=", "value": periodicity, "joinoperator": "and" });
      }
    
    this.fciwebservice.getmsikpiData(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
            if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.miskpiZoneList = response.result.sec_1;
            // console.log(this.miskpiZoneList);
            if(response.result.sec_1.length > 0){
              this.totalRecords = response.result.sec_1[0].noOfRec;
              this.issearch = true;             
            } else {
              this.totalRecords = 0;
              this.issearch = false;
            }
      }
    }
    });

  }
 

  getCodeFilesite(item:any):any{
    if(item.code==""){
      return "";
    }
    if(item.code_details==undefined){
      return "";
    }
    if(item.code_details.fileSize==undefined){
      return "";
    }
    if(item.code_details.fileSize==""){
      return "";
    }
    return `${item.code_details.fileSize}`;
  }

  getFilesite(item:any):any{
    if(item.kPINumber==""){
      return "";
    }
    if(item.kPINumber_details==undefined){
      return "";
    }
    if(item.kPINumber_details.fileSize==undefined){
      return "";
    }
    if(item.kPINumber_details.fileSize==""){
      return "";
    }
    return `${item.kPINumber_details.fileSize}`;
  }

htmlTag(data:any){
  return this.encDec.decodeHtml(data);
}

getDivisionName(data: any):any {
  let n:any='';
  this.circularDivList.forEach((element:any) => {
    if(element.id==data.selectDivision){
      n = this.language=='English'?element.name:element.nameInHindi;
    }
  });
  return n;
  // console.log(data.selectDivision);
  // const jsonOptTxtDetails = JSON.parse(data.jsonOptTxtDetails);
  // return jsonOptTxtDetails.INTCIRCULARDIV;
}
getPeriodcity(data: any):string {
  const jsonOptTxtDetails = JSON.parse(data.jsonOptTxtDetails);
  return this.PeriodcityLanguage(jsonOptTxtDetails.VCHPERIODCITY);
}

PeriodcityLanguage(d:any){

  let val=d;
  if(d=='Daily'){
    if(this.language=='Hindi'){
      val="दैनिक";
    }
  }

  if(d=='Fortnightly'){
    if(this.language=='Hindi'){
      val="पाक्षिक";
    }
  }
  if(d=='Half Yearly'){
    if(this.language=='Hindi'){
      val="अर्धवार्षिक";
    }
  }
  if(d=='Monthly'){
    if(this.language=='Hindi'){
      val="महीने के";
    }
  }
  if(d=='Quarterly'){
    if(this.language=='Hindi'){
      val="त्रैमासिक";
    }
  }
  if(d=='Yearly'){
    if(this.language=='Hindi'){
      val="बार्षिक";
    }
  }

  return val;

}

getPlaceorigin(data: any):string {
  const jsonOptTxtDetails = JSON.parse(data.jsonOptTxtDetails);

  let val=jsonOptTxtDetails.VCHORIGIN;

  if(jsonOptTxtDetails.VCHORIGIN=='Zone'){
    if(this.language=='Hindi'){
      val="अंचल";
    }
  }

  if(jsonOptTxtDetails.VCHORIGIN=='Region'){
    if(this.language=='Hindi'){
      val='क्षेत्र ';
    }
  }
  return val;
}


htmldecode(str: any){
  return this.encDec.decodeHtml(str);
}
get title() {
  return this.searchForm.get('title');
}
get division() {
  return this.searchForm.get('division');
}

get category() {
  return this.searchForm.get('category');
}
get periodicity() {
  return this.searchForm.get('periodicity');
}
get zone() {
  return this.searchForm.get('zone');
}
get region() {
  return this.searchForm.get('region');
}
pageChanged(page: any) {
  let param_arr = []; 
  let title,division,category,zone,region,periodicity;
  title="";
  category="";
  periodicity="";
  zone="";
  region="";
  division="";

  if(this.searchForm.value.title!==""){
    if(this.searchForm.value.title!==null){
      param_arr.push(this.searchForm.value.title);
      title = this.searchForm.value.title;
    }
  }
  
  if(this.searchForm.value.division!==""){
    if(this.searchForm.value.division!==null){
      param_arr.push(this.searchForm.value.division);
      division = this.searchForm.value.division;
    }
  }
  if(this.searchForm.value.category!==""){
    if(this.searchForm.value.category!==null){
      param_arr.push(this.searchForm.value.category);
      category = this.searchForm.value.category;
    }
  }
  if(this.searchForm.value.periodicity!==""){
    if(this.searchForm.value.periodicity!==null){
      param_arr.push(this.searchForm.value.periodicity);
      periodicity = this.searchForm.value.periodicity;
    }
  }
  if(this.searchForm.value.zone!==""){
    if(this.searchForm.value.zone!==null){
      param_arr.push(this.searchForm.value.zone);
      zone = this.searchForm.value.zone;
    }
  }
  if(this.searchForm.value.region!==""){
    if(this.searchForm.value.region!==null){
      param_arr.push(this.searchForm.value.region);
      region = this.searchForm.value.region;
    }
  }
  this.currentPage=page
  this.start=(this.currentPage - 1)*this.limit;
  
  this.getmiskpiZoneData('','','','',environment.ZONE_ID,'',this.start,this.limit,this.currentPage);
}

ifdisabled:boolean=false;
btncontent:any = `Search`;
issearch:any;
searchMISKPIZoneList(){
  let param_arr = []; 
  this.isdisplay = true;
  let title,category,periodicity,division,zone,region;
  title="";
  category="";
  periodicity="";
  division ="";
  zone="";
  region="";
  
  if(this.searchForm.value.title!==""){
    if(this.searchForm.value.title!==null){
      param_arr.push(this.searchForm.value.title);
      title = this.searchForm.value.title;
    }
  }
  if(this.searchForm.value.division!==""){
    if(this.searchForm.value.division!==null){
      param_arr.push(this.searchForm.value.division);
      division = this.searchForm.value.division;
    }
  }
  if(this.searchForm.value.category!==""){
    if(this.searchForm.value.category!==null){
      param_arr.push(this.searchForm.value.category);
      category = this.searchForm.value.category;
    }
  }
  if(this.searchForm.value.periodicity!==""){
    if(this.searchForm.value.periodicity!==null){
      param_arr.push(this.searchForm.value.periodicity);
      periodicity = this.searchForm.value.periodicity;
    }
  }
  if(this.searchForm.value.zone!==""){
    if(this.searchForm.value.zone!==null){
      param_arr.push(this.searchForm.value.zone);
      zone = this.searchForm.value.zone;
    }
  }
  if(this.searchForm.value.region!==""){
    if(this.searchForm.value.region!==null){
      param_arr.push(this.searchForm.value.region);
      region = this.searchForm.value.region;
    }
  }
  if(param_arr.length <= 0){
   
    Swal.fire({
      icon: 'warning',
      text: (this.language=='English') ? "Please select at least one parameter" : "कृपया कम से कम एक पैरामीटर चुनें",
    });
    return;
  }
  this.RefreshBtn=true;
  this.start=0;
  this.limit=10;
  this.currentPage = 1;
  this.totalRecords = 0;
  this.getmiskpiZoneData(title,division,category,periodicity,environment.ZONE_ID,'',this.start,this.limit,this.currentPage);
}
region_apirespons: any;
  regionList: any[] = [];
  GetRegion(val:any){
    this.regionList = [];
    let p = {'zone_id':val};
    if(val==""){
      return;
    }
    this.httpservice.GetRegionByZoneId(p).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.region_apirespons = response.body;
          let respData = this.region_apirespons.RESPONSE_DATA;
          let respToken = this.region_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.regionList = res.original.data;
          }
      }
    });
  }

  zone_apirespons: any;
  zoneList: any[] = [];
  ZoneList() { 
    this.httpservice.getZoneList().subscribe((response: HttpEvent<any>) => {
      switch (response.type) { 
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.zone_apirespons = response.body;
          let respData = this.zone_apirespons.RESPONSE_DATA;
          let respToken = this.zone_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.zoneList = res.original.data;
          } 
      }
    });
  }  

  GetAllZoneById(zoneid:any) { 
    this.zoneList = [];
    this.regionList = [];
    this.httpservice.GetAllZoneById({'zone_id':zoneid}).subscribe((response: HttpEvent<any>) => { 
      switch (response.type) { 
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.zone_apirespons = response.body;
          let respData = this.zone_apirespons.RESPONSE_DATA;
          let respToken = this.zone_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.zoneList = res.original.list;
          } 
      }
    });
  }

  checkCodeFileType(data:any):any{
    let ext:any,fileType:any;
    ext= ['webp','jpeg', 'jpe', 'png', 'gif', 'jpg', 'pdf', 'PNG','xlsx','xls','csv','docx','doc'];
    if(data==""){
      return false; 
    }  
    if(data.code==""){
      return false; 
    }
    if(data.code_details==undefined){
      return false; 
    }
    if(data.code_details.fileType==undefined){
      return false; 
    }
    if(data.code_details.fileType==''){
      return false; 
    }
    fileType=data.code_details.fileType.toLowerCase();
    if(fileType=='xlsx' || fileType=='xls' || fileType=='csv'){
      return {'fileType':fileType,'file': `|| <i class="fa fa-file-excel-o" aria-hidden="true"></i> ${fileType}`}; 
    } else if(fileType=='docx' || fileType=='doc'){
      return {'fileType':fileType,'file':`|| <i class="fa fa-file-word-o" aria-hidden="true"></i> ${fileType}`}; 
    } else if(fileType=='pdf'){
      return {'fileType':fileType,'file':`|| <i class="fa fa-file-pdf-o" aria-hidden="true"></i> ${fileType}`}; 
    } else {
      return {'fileType':fileType,'file':`|| <i class="fa fa-file-text" aria-hidden="true"></i> ${fileType}`}; 
    }
  }


  checkFileType(data:any):any{
    let ext:any,fileType:any;
    ext= ['webp','jpeg', 'jpe', 'png', 'gif', 'jpg', 'pdf', 'PNG','xlsx','xls','csv','docx','doc'];
    if(data==""){
      return false; 
    }  
    if(data.kPINumber==""){
      return false; 
    }
    if(data.kPINumber_details==undefined){
      return false; 
    }
    if(data.kPINumber_details.fileType==undefined){
      return false; 
    }
    if(data.kPINumber_details.fileType==''){
      return false; 
    }
    fileType=data.kPINumber_details.fileType.toLowerCase();
    if(fileType=='xlsx' || fileType=='xls' || fileType=='csv'){
      return {'fileType':fileType,'file': `|| <i class="fa fa-file-excel-o" aria-hidden="true"></i> ${fileType}`}; 
    } else if(fileType=='docx' || fileType=='doc'){
      return {'fileType':fileType,'file':`|| <i class="fa fa-file-word-o" aria-hidden="true"></i> ${fileType}`}; 
    } else if(fileType=='pdf'){
      return {'fileType':fileType,'file':`|| <i class="fa fa-file-pdf-o" aria-hidden="true"></i> ${fileType}`}; 
    } else {
      return {'fileType':fileType,'file':`|| <i class="fa fa-file-text" aria-hidden="true"></i> ${fileType}`}; 
    }
  }

}


